














import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class TimeLineItem extends Vue {
  @Prop({default: true})
  private isExercise!: boolean;

  @Prop()
  private id!: string;

  @Prop({default: ''})
  private src!: string;

  @Prop()
  private title!: string;

  @Prop()
  private duration!: string;

  @Prop()
  private widthItem!: string;

  @Prop()
  private colorItem!: string;

  private handleRemove() {

  }
}
